'use strict';

define('features/ctas/raq.cta',[
  'jquery',
  './cta.types',
  'lib/util/tda.config'
], function (
  $,
  ctaTypes,
  tdaConfig
) {
  var __type = ctaTypes['raq']; // eslint-disable-line dot-notation
  var __defaultUrl = '/' + tdaConfig.site.context_url + '/request-a-quote/'; // is this always the case?

  /* TODO: */

  return function raqCta(offerId, $scope) {
    var $ctaScope = $scope || $('body');
    var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);

    if (!$ctas.length) return;
    if (!offerId) return; // XSLS output the proper default so far, else we can modify using __defaultUrl

    $ctas.each(function () {
      $(this).attr('href', __defaultUrl + '?offerId=' + offerId);
    });
  };
});

